import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  Col,
  notification,
  Pagination,
  Row,
  Table,
  Typography,
} from 'antd';
import type { ColumnsType } from 'antd/es/table';
import axios from 'axios';
import EdoSearchModal from './EdoSearchModal';
import EdoSearchRemarkModal from './EdoSearchRemarkModal';

import { IDocument, ISearchResult } from '.';
import dayjs from 'dayjs';
import api from '../services/api';

const { Title } = Typography;

interface EdoSearchResultProps {
  searchResult: ISearchResult;
  paramSearch: any;
  onSetSearchResult: (searchResult, paramSearch) => void;
  currentPage: number;
  setCurrentPage: any;
}

interface IDocumentColumns extends IDocument {
  key?: React.Key;
}

function EdoSearchResult(props: EdoSearchResultProps) {
  const [isVisibleCordinationModal, setIsVisibleCordinationModal] =
    useState(false);
  const [isVisibleRemarkModal, setIsVisibleRemarkModal] = useState(false);
  const { searchResult, paramSearch, onSetSearchResult = () => {} } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [modalData, setModalData] = useState();
  const handleOk = () => {
    setIsVisibleCordinationModal(false);
    setIsVisibleRemarkModal(false);
  };

  const handleCancel = () => {
    setIsVisibleCordinationModal(false);
    setIsVisibleRemarkModal(false);
  };
  const showCoordinationModal = (data) => {
    setIsVisibleCordinationModal(true);
    setModalData(data);
  };
  const showRemarkModal = (data) => {
    setIsVisibleRemarkModal(true);
    setModalData(data);
  };
  const columns: ColumnsType<IDocumentColumns> = [
    {
      title: 'Тип документа',
      key: 'class',
      width: 200,
      render: (_, record) => (
        <Link to={record.id.toString()}>{record.class?.full_name}</Link>
      ),
    },
    {
      title: '№',
      dataIndex: 'document_id',
      key: 'document_id',
      width: 200,
    },
    {
      title: 'Куратор',
      key: 'employee_name',
      dataIndex: 'employee_name',
      width: 200,
      render: (_, record) =>  record?.employee_name,
    },
    {
      title: 'Дата',
      key: 'date',
      width: 60,
      render: (_, record) =>
        dayjs(record.date).isValid()
          ? dayjs(record.date).format('DD.MM.YYYY')
          : '',
    },
    {
      title: 'Контрагент',
      key: 'client',
      width: 200,
      render: (_, record) => record?.contractor_name,
    },
    {
      title: 'Примечание',
      dataIndex: 'remark',
      key: 'remark',
      width: 150,
      render: (_, record) => {
        if (record?.remark?.length > 0) {
          return (
            <a onClick={(e) => showRemarkModal(record)}>Открыть примечание</a>
          );
        } else {
          return <p>Пустое примечание</p>;
        }
      },
    },
    {
      title: 'Статус',
      key: 'status',
      width: 120,
      render: (_, record) => record.stage?.name,
    },
    {
      title: 'Действия',
      width: 70,
      render: (_, record) =>
        record.coordination.length > 0 ? (
          <a onClick={(e) => showCoordinationModal(record)}>Согласующие</a>
        ) : (
          ''
        ),
    },
  ];

  const paginate = async (pageNumber: number) => {
    try {
      setIsLoading(true);

      const { data } = await api.searchDocuments(pageNumber, paramSearch);
      props.setCurrentPage(pageNumber);

      onSetSearchResult(data, paramSearch);
    } catch (error) {
      let message;

      if (axios.isAxiosError(error)) {
        message = error.message;
      } else {
        message = String(error);
      }

      notification.info({
        message: 'Ошибка',
        description: message,
      });
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (props.currentPage) {
      if (props.currentPage !== searchResult.meta.current_page) {
        paginate(props.currentPage);
      }
    }
  }, [props.currentPage]);

  return (
    <Card data-testid="edo-search-result" className="mt-5">
      <Title level={5} type="secondary" className="mb-5">
        Результаты поиска
      </Title>
      {!!searchResult.data.length ? (
        <>
          <Table
            columns={columns}
            dataSource={searchResult.data}
            scroll={{ y: 400, x: 2000 }}
            bordered
            pagination={false}
            loading={isLoading}
          />
          <EdoSearchModal
            visible={isVisibleCordinationModal}
            handleOk={handleOk}
            handleCancel={handleCancel}
            data={modalData}
          />
          <EdoSearchRemarkModal
            visible={isVisibleRemarkModal}
            handleOk={handleOk}
            handleCancel={handleCancel}
            data={modalData}
          />

          <Row className="mt-4" justify="end">
            <Col>
              <Pagination
                current={searchResult.meta.current_page}
                pageSize={searchResult.meta.per_page}
                total={searchResult.meta.total}
                showSizeChanger={false}
                onChange={paginate}
                disabled={isLoading}
              />
            </Col>
          </Row>
        </>
      ) : (
        <p>По вашему запросу ничего не найдено</p>
      )}
    </Card>
  );
}

export default EdoSearchResult;
